<template>
  <div @click="$emit('click')">
    <i class="more-options far fa-ellipsis-h" :class="active ? 'active' : ''"></i>
  </div>
</template>

<script>
  export default {
    props: {
      active: Boolean
    }
  }
</script>